import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

const startApp = () => {
  ReactDOM.render(
    <App />,
    document.getElementById('root')
  );
}
startApp()



// WEBPACK FOOTER //
// ./src/index.js